module.exports = __webpack_public_path__ + "img/KilljoyArtwork.5cf907d3.png";